import { GODS_ONLY, ADMINS } from "../../config/roleConfig";

export function isGod(role, subrole) {
  try {
    return ADMINS.includes(role) && GODS_ONLY.includes(subrole);
  } catch (e) {
    return false;
  }
}
